// HACK: This is a temporary hack to display static billing prices for companies during migration
// File and function should be renamed
function getStripeProduct(companyId) {
    switch (companyId) {
        case 179:
            return 40;
        case 174:
        case 173:
        case 158:
            return 20;
        case 164:
            return 320;
        case 123:
            return 760;
        case 115:
        case 93:
            return 100
        case 54:
            return 950;
        default:
            return 0;
    }
}

module.exports = {
    getStripeProduct,
};
